import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import MaterialTable from "material-table";
import {
  showNotification,
  withDataProvider,
  Loading,
  GET_LIST,
  Title
} from "react-admin";

const styles = {};
class ProductList extends Component {
  state = { loadingListProduct: false, dataProduct: null };

  getData = () => {
    const { dataProvider, dispatch } = this.props;

    dataProvider(GET_LIST, "products/get/list/complete", null)
      .then(({ data }) => {
        //data = data.filter(prod => prod.discontinued === false);
        this.setState({ loadingListProduct: true, dataProduct: data });
      })
      .catch(error => {
        dispatch(showNotification(error.message, "error"));
      });
  };

  componentDidMount() {
    this.getData();
  }

  render() {
    const { loadingListProduct, dataProduct } = this.state;
    return loadingListProduct ? (
      <div>
        <Title>Productos</Title>
        <MaterialTable
          tableRef={this.tableRef}
          options={{
            pageSize: 10
          }}
          //       <TextField source="unit" />
          //       <BooleanField source="canBeSold" />
          //       <BooleanField source="canBePurchased" />
          //       <TextField source="notes" />
          //       <TextField source="id" />
          columns={[
            { title: "Id", field: "productId" },
            { title: "Código", field: "code" },
            { title: "Descripción", field: "description" },
            { title: "Precio Unit.", field: "unitPrice" },
            { title: "Descontinuado", field: "discontinued" },
            { title: "Min. Producto", field: "minProduct" },
            { title: "Max. Producto", field: "maxProduct" },
            { title: "Unidad", field: "unit" }
          ]}
          data={dataProduct}
          title="Productos"
        />
      </div>
    ) : (
      <Loading />
    );
  }
}

export default withStyles(styles)(withDataProvider(ProductList));
